// extracted by mini-css-extract-plugin
export default {"redTextWrapper":"entityInformation_redTextWrapper__zYpGv"};